import { useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import {
  Container,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Row,
  Col,
  Spinner,
  Card,
  CardBody,
  Table,
} from "reactstrap";
import Link from "next/link";
import {
  MdOutlineAdd,
  MdOutlineReceiptLong,
  MdOutlineRefresh,
  MdPlace,
  MdPublic,
  MdSettings,
} from "react-icons/md";

//local imports
import uspsClasses from "@/styles/partners/usps.module.css";
import classes from "@/styles/partners/partner.module.css";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
import { logo, smallLogo } from "@/utils/images";
import { partner as p } from "@/utils/content";
import { useIsMobile } from "@/hooks/useIsMobile";

const USPSMain = () => {
  const router: any = useRouter();
  const partnerDetails: any = fulfillmentPartners.find(
    (t) => t.url === `/usps`
  );
  const isMobile = useIsMobile();

  const content = p.en;
  const [open2, setOpen2] = useState<string>("1");

  //@ts-ignore
  const toggle2 = (id) => {
    if (open2 === id) {
      //@ts-ignore
      setOpen2();
    } else {
      setOpen2(id);
    }
  };

  return (
    <div className={classes.container}>
      {!partnerDetails ? (
        <Spinner className="m-auto" animation="border" role="status"></Spinner>
      ) : (
        <>
          <div className={classes.hero}>
            <div>
              <Image
                className={`${isMobile ? "me-4" : "ms-5"} img-fluid`}
                src={isMobile ? smallLogo : logo}
                alt="ShipVista logo"
                height={80}
                width={isMobile ? 80 : 300}
              />
            </div>
            <div>
              <MdOutlineAdd className={`text-darkblue ${classes.plusIco}`} />
            </div>
            <div>
              <Image
                className={`img-fluid ${
                  isMobile ? `${classes.heroImg}` : "me-5"
                }`}
                src={partnerDetails.logoPath}
                alt={partnerDetails.name}
                height={150}
                width={250}
              />
            </div>
          </div>
          <div className={classes.main}>
            <Container>
              <section className="my-3">
                <p className={`fw-bold my-5 inter ${isMobile ? "" : "w-50"}`}>
                  {content.shipVistaPartnerTitle(partnerDetails.name)}
                </p>
                <h1 className="lato">
                  {content.about}&nbsp;{partnerDetails.name}
                </h1>
                <p className={`inter`}>
                  {partnerDetails.about ? partnerDetails.about : "N/A"}
                </p>
              </section>
              <section className="my-5">
                <Row>
                  <Col xs={12} lg={6}>
                    <h2 className="lato mt-5 mb-3">
                      {partnerDetails.title1 ? partnerDetails.title1 : "N/A"}
                    </h2>
                    <p className="inter">
                      {partnerDetails.para1 ? partnerDetails.para1 : "N/A"}
                    </p>
                  </Col>
                  <Col
                    className="d-flex justify-content-center align-items-center"
                    xs={12}
                    lg={6}
                  >
                    <Image
                      src={partnerDetails.image1}
                      alt={partnerDetails.image1}
                      height={275}
                      width={270}
                    />
                  </Col>
                </Row>
              </section>
              <section className="my-5 pt-5 pb-5">
                <Row>
                  <Col xs={12} lg={6}>
                    <div className="mt-5 pt-3">
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className={`d-grid ${classes.cardGrid}`}>
                            <div
                              className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                            >
                              <MdSettings />
                            </div>
                            <p className="ps-3 pt-2 mt-1">
                              Automate shipping tasks
                            </p>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className={`d-grid ${classes.cardGrid}`}>
                            <div
                              className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                            >
                              <MdOutlineRefresh />
                            </div>
                            <p className="ps-3">
                              Sync your orders directly from your store
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className={isMobile ? "mt-2" : "mt-5"}>
                        <Col xs={12} sm={6}>
                          <div className={`d-grid ${classes.cardGrid}`}>
                            <div
                              className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                            >
                              <MdOutlineReceiptLong />
                            </div>
                            <p className={"ps-3"}>
                              Full clarity on import tax & duties
                            </p>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className={`d-grid ${classes.cardGrid}`}>
                            <div
                              className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                            >
                              <MdPublic />
                            </div>
                            <p className="ps-3">
                              Expand your business using our global fulfillment
                              network
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className={isMobile ? "mt-2" : "mt-5"}>
                        <Col xs={12} sm={6}>
                          <div className={`d-grid ${classes.cardGrid}`}>
                            <div
                              className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                            >
                              <MdPlace />
                            </div>
                            <p className="ps-3">
                              Best-in-class shipment tracking
                            </p>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}></Col>
                      </Row>
                      <p>{partnerDetails.para5 && partnerDetails.para5}</p>
                    </div>
                  </Col>
                  <Col className="mt-3" xs={12} lg={6}>
                    <h4>
                      {partnerDetails.title2 ? partnerDetails.title2 : "N/A"}
                    </h4>
                    <ol>
                      {partnerDetails.list1 &&
                        partnerDetails.list1.map((l: string, i: number) => (
                          <li key={i}>{l}</li>
                        ))}
                    </ol>
                    <p>{partnerDetails.para4 && partnerDetails.para4}</p>
                  </Col>
                  <Col className="mt-3" xs={12} lg={6}>
                    <h4>ShipVista offers the following USPS API services:</h4>
                    <ol>
                      <li>Address Information (Address Verification)</li>
                      <li>Tracking & Delivery Information</li>
                      <li>Price Calculator</li>
                      <li>Print Shipping Labels</li>
                      <li>Package Pickup</li>
                      <li>Postage / Label Purchasing</li>
                    </ol>
                    <p>{partnerDetails.para4 && partnerDetails.para4}</p>
                  </Col>
                </Row>
              </section>
              <section className="my-5">
                <div className={classes.bigCard}>
                  <h2 className="lato text-center m-t">
                    {partnerDetails.title3}
                  </h2>
                  <p className="inter text-center">{partnerDetails.para3}</p>
                  {partnerDetails.serviceCards && (
                    <Row className="mt-5">
                      {partnerDetails.serviceCards.map(
                        (
                          s: {
                            title: string;
                            desc: string;
                            link: string;
                          },
                          i: number
                        ) => (
                          <Col key={i} xs={12} lg={4}>
                            <Link
                              className={classes.link + " shadow-lg"}
                              href={`/partners${s.link}`}
                            >
                              <Card className={uspsClasses.blueCard}>
                                <CardBody>
                                  <h2 className={classes.blueCardHeading}>
                                    {s.title}
                                  </h2>
                                  <p className={classes.blueCardPara}>
                                    {s.desc}
                                  </p>
                                </CardBody>
                              </Card>
                            </Link>
                          </Col>
                        )
                      )}
                    </Row>
                  )}
                  <div className={`text-center mt-3 ${isMobile ? "" : "fs-4"}`}>
                    <p>
                      These services vary in delivery time, cost, and package
                      size, and the USPS provides detailed information on each
                      on its website.
                    </p>
                    <p>
                      You can manage all USPS shipment aspects within ShipVista.
                      Our all-in-one shipping platform enables you to compare
                      your USPS rates to other couriers, access pre-negotiated
                      discounted rates, and optimize your shipping experience
                      with powerful automation.
                    </p>
                  </div>
                </div>
                <div className="mt-3">
                  <h4>Service Levels:</h4>
                  <p className={` ${isMobile ? "" : "fs-5 w-75"}`}>
                    USPS has eleven service levels supported by ShipVista.
                    Service levels have to do with both the speed and type of
                    shipments. Each service level is detailed below. For
                    reference, Girth is 2 times (Width + Height).
                  </p>
                  <Table
                    responsive
                    bordered
                    striped
                    className={`border border-3 border-dark m-0 ${
                      isMobile ? "" : "w-75"
                    }`}
                  >
                    <thead className="text-white bg-dark-blue fw-bolder">
                      <tr>
                        <th>Service</th>
                        <th>Transit Time</th>
                        <th>Max Dimensions</th>
                        <th>Max Weight</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>First Class (Letters and Flats)</td>
                        <td>1-3 days</td>
                        <td>
                          22&#34; x 18&#34; x 15&#34; (55 cm x 45 cm x 38 cm)
                        </td>
                        <td>13 oz (368 g)</td>
                      </tr>
                      <tr>
                        <td>First Class Package Service</td>
                        <td>1-3 days</td>
                        <td>
                          22&#34; x 18&#34; x 15&#34; (55 cm x 45 cm x 38 cm)
                        </td>
                        <td>15.99 oz (453 g)</td>
                      </tr>
                      <tr>
                        <td>Priority</td>
                        <td>2-3 days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>Express</td>
                        <td>1-2 days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>Parcel Select</td>
                        <td>2-8 business days</td>
                        <td>
                          Combined Length and Girth &lt; 130&#34; (330 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>Library Mail</td>
                        <td>2-8 business days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>Media Mail</td>
                        <td>2-8 business days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>First Class Package International</td>
                        <td>7-21 days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>64 oz (1814 g)</td>
                      </tr>
                      <tr>
                        <td>Priority Mail International</td>
                        <td>6-10 business days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                      <tr>
                        <td>Express Mail International</td>
                        <td>3-5 business days</td>
                        <td>
                          Combined Length and Girth &lt; 108&#34; (274 cm)
                        </td>
                        <td>70 lbs (31 kg)</td>
                      </tr>
                    </tbody>
                  </Table>
                  <Table
                    responsive
                    bordered
                    striped
                    className={`border border-3 border-dark m-0 mt-5 ${
                      isMobile ? "" : "w-75"
                    }`}
                  >
                    <thead className="text-white bg-dark-blue fw-bolder">
                      <tr>
                        <th>Domestic Prices Service</th>
                        <td>Prices</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Priority Mail Express®</th>
                        <td>
                          <div>From $28.75 at the Post Office™</div>
                          <div>From $24.90 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Priority Mail Express Flat Rate Envelope</th>
                        <td>
                          <div>$28.75 at the Post Office</div>
                          <div>$24.90 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          Priority Mail Express Open &amp; Distribute® Service
                        </th>
                        <td>
                          <div>
                            See your USPS® sales agent for Commercial pricing
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Priority Mail®</th>
                        <td>
                          <div>From $9.35 at the Post Office</div>
                          <div>From $7.64 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Priority Mail Flat Rate® Envelope</th>
                        <td>
                          <div>$9.65 at the Post Office</div>
                          <div>$8.05 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Prepaid Forever Priority Mail Flat Rate</th>
                        <td>
                          <div>See pricing online</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Priority Mail Open &amp; Distribute® Service</th>
                        <td>
                          <div>
                            See your USPS® sales agent for Commercial pricing
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Priority Mail Return® Service</th>
                        <td>
                          <div>From $7.64 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>First-Class Mail®</th>
                        <td>
                          <div>From $0.63 at the Post Office</div>
                          <div>From $0.471 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>First-Class Package Service®</th>
                        <td>
                          <div>From $4.75 at the Post Office</div>
                          <div>From $3.59 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>First-Class Package Return® Service</th>
                        <td>
                          <div>From $3.59 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>USPS Marketing Mail®</th>
                        <td>
                          <div>From $0.183 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Every Door Direct Mail - Retail®</th>
                        <td>
                          <div>$0.189 for Flats up to 3.3 oz</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Parcel Select®</th>
                        <td>
                          <div>From $3.78 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Parcel Select Lightweight®</th>
                        <td>
                          <div>From $2.46 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          USPS Connect™ Local (available in select ZIP Codes™)
                        </th>
                        <td>
                          <div>
                            From $3.95 online with Click-N-Ship® service
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>USPS Retail Ground®</th>
                        <td>
                          <div>From $8.95 at the Post Office</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Ground Return Service</th>
                        <td>
                          <div>From $6.99 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Media Mail®</th>
                        <td>
                          <div>From $3.65 at the Post Office</div>
                          <div>From $2.32 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Bound Printed Matter</th>
                        <td>
                          <div>Varies</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Library Mail</th>
                        <td>
                          <div>From $3.47 at the Post Office</div>
                          <div>From $2.20 for Commercial Pricing</div>
                        </td>
                      </tr>
                      <tr>
                        <th>Periodicals</th>
                        <td>
                          <div>Varies</div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </section>
              <section className="pt-4 mb-5 border-top">
                <h2>USPS Pickups</h2>
                <p>
                  If you have one of the following package types ready for
                  transportation, USPS will pick it up free of charge:
                </p>
                <ul>
                  <li>Express Mail</li>
                  <li>Priority Mail</li>
                  <li>Returned Merchandise</li>
                  <li>International</li>
                  <li>First Class Package Service</li>
                </ul>
                <p>
                  To be picked up that day, requests must be made before 2:00 AM
                  CST. The USPS will pick up your packages the following
                  business day after 2:00 AM CST. Before shipping, packages must
                  be properly sealed.
                </p>
                <h5>Carrier Pick up:</h5>
                <p>
                  Schedule a package pickup at no additional cost (Monday
                  through Saturday, excluding holidays).
                </p>
                <h5>Schedule Carrier Pickup:</h5>
                <ol>
                  <li>
                    Provide a location to determine if the address is available
                    for a Carrier Pickup.
                  </li>
                  <li>Schedule a Carrier Pickup </li>
                </ol>
                <p>Pickup appointment as needed.</p>
                <h5>Mail classes supported for Carrier Pickup:</h5>
                <ul>
                  <li>Priority Mail Express</li>
                  <li>Priority Mail</li>
                  <li>First Class Package Service</li>
                  <li>International</li>
                  <li>First-Class Package Return Service</li>
                  <li>Ground Return Service</li>
                  <li>Priority Mail Return Service</li>
                  <li>Parcel Return Service</li>
                </ul>
              </section>
              <section className="pt-5 mb-5 border-top">
                <h3>USPS Tracking®</h3>
                <p>
                  Track packages anytime anywhere on the ShipVista platform.
                </p>
                <p>
                  Enter your tracking number to obtain near-real-time visibility
                  of shipments as packages move throughout the USPS network from
                  induction to delivery.
                </p>
                <h5>FAQ about Tracking</h5>
                <Accordion
                  className={`my-4 ${isMobile ? "" : "w-50"}`}
                  open={open2}
                  //@ts-ignore
                  toggle={toggle2}
                >
                  <AccordionItem>
                    <AccordionHeader targetId="a21">
                      What does my tracking number look like?
                    </AccordionHeader>
                    <AccordionBody accordionId="a21">
                      <Table
                        responsive
                        striped
                        bordered
                        className="border border-3 border-dark mt-4"
                      >
                        <thead className="text-white bg-dark-blue fw-bolder">
                          <tr>
                            <th>SERVICE</th>
                            <th>SAMPLE NUMBER</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Priority Mail Express International®</td>
                            <td>EC 000 000 000 US</td>
                          </tr>
                          <tr>
                            <td>Priority Mail Express®</td>
                            <td>
                              <div>9270 1000 0000 0000 0000 00</div>
                              <div>EA 000 000 000 US</div>
                            </td>
                          </tr>
                          <tr>
                            <td>Priority Mail International®</td>
                            <td>CP 000 000 000 US</td>
                          </tr>
                          <tr>
                            <td>Registered Mail™</td>
                            <td>9208 8000 0000 0000 0000 00</td>
                          </tr>
                          <tr>
                            <td>Signature Confirmation™</td>
                            <td>9202 1000 0000 0000 0000 00</td>
                          </tr>
                        </tbody>
                      </Table>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeader targetId="a22">
                      Where do I find my tracking number?
                    </AccordionHeader>
                    <AccordionBody accordionId="a22">
                      <p>
                        Your tracking number can be found in the following
                        places:
                      </p>
                      <ul>
                        <li>Your Post Office™ shipping receipt</li>
                        <li>
                          Your sales receipt if you bought insurance at the Post
                          Office™
                        </li>
                        <li>
                          Your email confirmation if you shipped from USPS.com
                        </li>
                        <li>
                          The shipping confirmation email you received from
                          ShipVista
                        </li>
                        <li>
                          The bottom peel-off portion of your USPS Tracking®
                          label
                        </li>
                      </ul>
                    </AccordionBody>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionHeader targetId="a23">
                      How can I leave delivery instructions?
                    </AccordionHeader>
                    <AccordionBody accordionId="a23">
                      <p>
                        If a package qualifies for the USPS Delivery
                        Instructions™ service, you can tell USPS where to leave
                        a package at your address, send it to a different
                        address, or send it to your Post Office.
                      </p>
                      <p>
                        Click <b>Change Delivery Instructions</b> on the
                        tracking results page to leave your request. If you do
                        not see the <b>Change Delivery Instructions</b> link,
                        your package is not eligible for the Delivery
                        Instructions service.
                      </p>
                      <h6>
                        <b>No “Delivery Instructions” Link</b>
                      </h6>
                      <p>
                        There are several reasons a package may not be eligible
                        for Delivery Instructions.
                      </p>
                      <p>Ineligible packages may have:</p>
                      <ul>
                        <li>Already left the Post Office for delivery</li>
                        <li>A Hold Mail request</li>
                        <li>A Forward Mail request</li>
                        <li>A military (APO/FPO) or DPO address</li>
                        <li>An international sender</li>
                        <li>A Delivery Signature request</li>
                        <li>A Collect on Delivery (COD) request</li>
                        <li>An active USPS Package Intercept® order</li>
                        <li>Insurance for $500 or more</li>
                      </ul>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </section>
              <section className="pt-5 mb-5 border-top">
                <div>
                  <h2>USPS Package Restrictions</h2>
                  <p>
                    <strong>
                      Below are all the necessary numbers if you need to know
                      how large a USPS parcel can be.
                    </strong>
                  </p>
                  <h5>What package restrictions does USPS have?</h5>
                  <div className={` ${isMobile ? "" : "w-50"}`}>
                    <p>
                      The chart below shows the USPS First Class Package size
                      restrictions, the USPS First Class Package weight limit,
                      and USPS package size limits, as well as additional useful
                      maximum package size information.
                    </p>
                    <p>
                      The Predefined Package names are drawn from the EasyPost
                      API, so you can better reference how each Predefined
                      Package matches up dimensionally.
                    </p>
                  </div>
                  <div>
                    <Table
                      responsive
                      striped
                      bordered
                      className={`border border-3 border-dark mt-4 ${
                        isMobile ? "" : "w-75"
                      }`}
                    >
                      <thead className="text-white bg-dark-blue fw-bolder">
                        <tr>
                          <th>Predefined Package Name</th>
                          <th>Dimensions</th>
                          <th>Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Card</td>
                          <td>
                            <ul>
                              <li>Min: 3 ½&#34; x 5 ½&#34;</li>
                              <li>Max: 4 ¼&#34; x 6&#34;</li>
                            </ul>
                          </td>
                          <td>Must be a flat surface</td>
                        </tr>
                        <tr>
                          <td>Letter</td>
                          <td>
                            <ul>
                              <li>Min: 3 ½&#34; x 5 ½&#34;</li>
                              <li>Max: 6 ⅛&#34; x 11 ½&#34;</li>
                            </ul>
                          </td>
                          <td>Maximum weight is 3.5 oz.</td>
                        </tr>
                        <tr>
                          <td>Flat</td>
                          <td>
                            <ul>
                              <li>Min: 6 ⅛&#34; x 11 ½&#34;</li>
                              <li>Max: 12&#34; x 15&#34;</li>
                            </ul>
                          </td>
                          <td>Maximum weight of 13 oz.</td>
                        </tr>
                        <tr>
                          <td>Parcel</td>
                          <td>
                            Maximum size is 108&#34; in combined length and
                            girth (distance around the thickest part).
                            First-Class™ packages cannot exceed 22&#34; x
                            18&#34; x 15&#34;.
                          </td>
                          <td>
                            Contents for Priority Mail Express, Priority Mail,
                            or Media Mail® must weigh less than 70 lbs.
                            First-Class™ packages must weigh less than 16 oz.
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRateEnvelope</td>
                          <td>12 ½&#34; x 9 ½&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRateLegalEnvelope</td>
                          <td>15&#34; x 9 ½&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRatePaddedEnvelope</td>
                          <td>12 ½&#34; x 9 ½&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRateGiftCardEnvelope</td>
                          <td>10&#34; x 7&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRateWindowEnvelope</td>
                          <td>10&#34; x 5&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>FlatRateCardboardEnvelope</td>
                          <td>12 ½&#34; x 9 ½&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>SmallFlatRateEnvelope</td>
                          <td>12 ½&#34; x 9 ½&#34;</td>
                          <td>
                            <ul>
                              <li>Contents must weigh less than 70 lbs.</li>
                              <li>International Weight limit: 4 lbs.</li>
                            </ul>
                          </td>
                        </tr>
                        <tr>
                          <td>SmallFlatRateBox</td>
                          <td>8 ⅝&#34; x 5 ⅜&#34; x 1 ⅝&#34;</td>
                          <td>Contents must weigh less than 70 lbs.</td>
                        </tr>
                        <tr>
                          <td>MediumFlatRateBox</td>
                          <td>11&#34; x 8 ½&#34; x 5 ½&#34;</td>
                          <td>Contents must weigh less than 70 lbs.</td>
                        </tr>
                        <tr>
                          <td>LargeFlatRateBox</td>
                          <td>12&#34; x 12&#34; x 5 ½&#34;</td>
                          <td>Contents must weigh less than 70 lbs.</td>
                        </tr>
                        <tr>
                          <td>LargeFlatRateBoardGameBox</td>
                          <td>
                            <ul>
                              <li>
                                23-11/16&#34; x 11 ¾&#34; x 3&#34; - Inside
                              </li>
                              <li>
                                24-1/16&#34; x 11 ⅞&#34; x 3 ⅛&#34; - Outside
                              </li>
                            </ul>
                          </td>
                          <td>Contents must weigh less than 70 lbs.</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <p className={` ${isMobile ? "" : "w-50"}`}>
                    Ready to start shipping your USPS packages? ShipVista offers
                    Commercial Plus Pricing to all customers, regardless of
                    volume. Discover how much you can save compared to retail
                    rates today with our USPS Rate Chart.
                  </p>
                </div>
              </section>
              <section className="pt-5 mb-5 border-top">
                <Row>
                  <Col xs={12} lg={3}>
                    <h2 className="lato fw-normal pt-4">{content.faq}</h2>
                    <p className="inter">
                      {content.faqPara(partnerDetails.name)}
                    </p>
                    <p>
                      United States Postal Service, also known as the Post
                      Office, U.S. Mail, or Postal Service, is an independent
                      agency of the executive branch of the United States
                      federal government responsible for providing postal
                      service in the U.S., including its insular areas and
                      associated states.
                    </p>
                  </Col>
                  <Col xs={12} lg={9}>
                    {partnerDetails.faqs && (
                      <>
                        <Accordion
                          className={`my-4 ${isMobile ? "" : "w-75"}`}
                          open={open2}
                          //@ts-ignore
                          toggle={toggle2}
                        >
                          {partnerDetails.faqs.map(
                            (
                              f: {
                                title: string;
                                desc: string;
                              },
                              i: string
                            ) => (
                              <AccordionItem key={i}>
                                <AccordionHeader targetId={(i + 1).toString()}>
                                  {f.title}
                                </AccordionHeader>
                                <AccordionBody accordionId={(i + 1).toString()}>
                                  <p>{f.desc}</p>
                                </AccordionBody>
                              </AccordionItem>
                            )
                          )}
                        </Accordion>
                      </>
                    )}
                  </Col>
                </Row>
              </section>
            </Container>
          </div>
        </>
      )}
    </div>
  );
};

export default USPSMain;
